import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3d7fc3de&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "App.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/App.vue
// module id = 945
// module chunks = 1